/** Daily patrols inherit applicable controls without changing the approved permit. */
export function applicableWorkDayChecklist<T extends { response: string }>(items: readonly T[]): T[] {
  return items.filter(item => item.response !== 'not-applicable');
}
